import { Box, Container, Divider, Flex, Table, Text } from "flicket-ui";
import { Footer, ContentContainer, FeaturedEvents } from "~components";
import React from "react";
import styled from "styled-components";
import { EventCard } from "./events.Card";
import { PointItemsQuery } from "~graphql/sdk";
import { CollapsibleSearch } from "./events.CollapsibleSearch";
import { EventsList } from "~features/events/hooks/useEventsService";
import { PointRow } from "./point-package.Row";

export interface ListProps {
  events: EventsList;
  setSearch: (search: string) => void;
  featuredEvents: EventsList;
  pointItems?: PointItemsQuery["pointItems"];
  pointName?: string;
}

const EventsContainer = styled(Box)`
  max-width: 100%;
  margin: 0 auto;
  padding: 0;
`;

export const List: React.FC<ListProps> = ({
  setSearch,
  events,
  featuredEvents,
  pointItems,
  pointName,
}) => {
  const showPoints = !!pointName && !!pointItems?.length;

  return (
    <ContentContainer variant="content">
      <Flex flexDir="column" flex="1">
        <Flex
          justifyContent="space-between"
          alignItems="center"
          width="100%"
          maxWidth="1248px"
          display={{ _: "none", md: "block" }}
        />

        <Container
          mb={6}
          innerProps={{
            borderRadius: { md: "md" },
            maxWidth: { _: "600px", sm: "880px", md: "100vw" },
            margin: "auto !important" as any,
          }}
        >
          <Flex
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            flexDirection="row"
            mb={2}
          >
            <Text variant="header.L" lineHeight="normal">
              Events
            </Text>
            <Box
              flex="1"
              maxWidth={{ _: "65%", md: "300px" }}
              display="flex"
              justifyContent="flex-end"
            >
              <CollapsibleSearch
                onChange={(value: string) => setSearch(value?.trim())}
                placeholder="Search events..."
                initialState={{ status: "collapsed" }}
                containerWidth={{
                  collapsed: "40px",
                  expanded: "300px",
                }}
              />
            </Box>
          </Flex>

          {!!featuredEvents?.length && (
            <>
              <Divider mb={4} />
              <Box mb={5}>
                <Text variant="header.Minor" mb={1}>
                  Featured
                </Text>
                <FeaturedEvents events={featuredEvents} />
              </Box>
            </>
          )}

          <EventsContainer>
            {events.length === 0 ? (
              <Box px={3} py={4} textAlign="center">
                <Text variant="regular">No events found.</Text>
              </Box>
            ) : (
              <Box width="100%" className="event-list-container">
                {events.map((event) => (
                  <EventCard
                    key={event.id}
                    id={event.id}
                    title={event.title}
                    venue={event.venue}
                    startDate={event.startDate}
                    endDate={event.endDate}
                    eventKind={event.eventKind}
                    hasPublicRelease={event.hasPublicRelease ?? false}
                    thumbnail={event.thumbnail}
                    logo={event.logo}
                    descriptionImage={event.descriptionImage}
                  />
                ))}
              </Box>
            )}
          </EventsContainer>

          {showPoints && (
            <Box mt={6} mb={2}>
              <Text variant="header.L" lineHeight="normal">
                {pointName}
              </Text>

              <Box mt={3}>
                <Table
                  data={pointItems}
                  row={(props) => <PointRow {...props} />}
                />
              </Box>
            </Box>
          )}
        </Container>
      </Flex>
      <Footer />
    </ContentContainer>
  );
};
